import { render, staticRenderFns } from "./PushNotificationAlert.vue?vue&type=template&id=81b66b4c"
import script from "./PushNotificationAlert.vue?vue&type=script&lang=js"
export * from "./PushNotificationAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports